export function myAccountMenuIOSDeepLink() {
  return `/?app=true&dom=account&act=show`;
}

export function myAccountMenuWithRefreshActionIOSDeepLink() {
  return `/?app=true&dom=account&act=show-refresh`;
}

export function removeFromWishlistIOSDeepLink(sku: string) {
  return `/myaccount/closet?app=true&dom=wishlist&act=remove-item&sku=${sku}`;
}

export function addToWishlistIOSDeepLink(sku: string) {
  return `/myaccount/closet?app=true&dom=wishlist&act=add-item&sku=${sku}`;
}

export function browseProductsByTierIOSDeepLink(tier: string) {
  return `/?app=true&dom=browse&act=filter&subscriptionLevel[]=${tier}`;
}

export function productUrlIOSDeepLink(sku: string) {
  return `/?app=true&dom=browse&act=detail&sku=${sku}`;
}

export function openUrlIOSDeepLink(url: string) {
  return `/?app=true&dom=app&act=open-url&url=${encodeURIComponent(url)}`;
}
